// extracted by mini-css-extract-plugin
export default {"productGrid":"G1-z","centerLink":"H1-z","productSection":"I1-z","item":"J1-z","ctaButton":"K1-z"};